import React, { useState, useEffect, useCallback } from 'react';

import Skeleton from 'react-loading-skeleton';
import { classNameTriskeleParser } from '../../utilities/customStyles';

import 'react-loading-skeleton/dist/skeleton.css';
import { useDispatch, useSelector } from 'react-redux';

import { selectWidgetFilters, setWidgetFilters } from '../../redux/actions/widgetFilters';
import GeneralAccess from '../../dataAccess/GeneralAccess';
import { useLocation, useNavigate } from 'react-router-dom';

const ChipsHeader = (props) => {
  const [chips, setChips] = useState(null);
  const dispatch = useDispatch();

  const topFilterData = useSelector(state => state.widgetFiltes);
  const location = useLocation();
  const [isViewHidden, setViewHidden] = useState(false);
  const navigate = useNavigate();
    const { clientId } = props;


  const setChipsFromResponse = (response) => {
    const filterOnArray = [];
    const loadedChips = response.data.sort(
      (a, b) => a.MeasureCtgySortOrdr - b.MeasureCtgySortOrdr
    ).map((el) => {
      const ChipClass = classNameTriskeleParser.bind(this, el.VisualNameOne, el.VisualTypeOne);
      if (el.VisualTypeOne === 'Enabled') {
        el.triskeleClass = {
          selected: ChipClass('Chip', 'Selected'),
          unselected: ChipClass('Chip', 'Unselected')
        };
      } else {
        el.triskeleClass = {
          selected: ChipClass('Chip'),
          unselected: ChipClass('Chip')
        };
      }
      filterOnArray.push(el.MeasureCategoryName);
      return el;
    });
    dispatch(setWidgetFilters(filterOnArray));
    setChips(loadedChips);
  };

  const setChipsSelected = (index) => {
    dispatch(selectWidgetFilters(chips[index].MeasureCategoryName));
  };

     const callTriskeleApi = useCallback(() => {
    GeneralAccess.getMeasureChips(clientId, topFilterData.selectedDate)
      .then((response) => {
        setChipsFromResponse(response);
      })
      .catch((error) => {
        console.error(error);
         navigate('/maintenance');
      });
  }, []);

  useEffect(() => {
      callTriskeleApi();

      if (location.pathname.includes('home/analytics/chart') || location.pathname.includes('home/editprofile')) {
         setViewHidden(true);
      } else {
        setViewHidden(false);
      }
    },
    [location, callTriskeleApi]
  );

 

  return (
    !isViewHidden && (
    <div className="chips-header">
      {!chips // skeleton
    && <Skeleton inline borderRadius="1rem" className="chips-header-skeleton-item" count={4} />}
      {chips // regular
    && chips.map((chip, index) => (
      <div
        key={index}
        className={`chips-header-main-item ${!topFilterData.widgetFiltes.includes(chip.MeasureCategoryName) ? chip.triskeleClass.unselected : chip.triskeleClass.selected}`}
        onClick={() => setChipsSelected(index)}
        >
        {chip.MeasureCategoryName}
      </div>
    ))}
    </div>
    )
  );
};
export default ChipsHeader;
